export default "__VITE_ASSET__BQUhr1Qq__"